var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxBoldMaximize2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 18.85C11 21.1 10.1 22 7.85 22h-2.7C2.9 22 2 21.1 2 18.85v-2.7C2 13.9 2.9 13 5.15 13h2.7c2.25 0 3.15.9 3.15 3.15v2.7z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.52 2C5.47 2 3 4.47 3 7.52v2.98c0 .55.45 1 1 1h4.5c2.21 0 4 1.79 4 4V20c0 .55.45 1 1 1h2.98c3.45 0 5.52-2.06 5.52-5.52V7.52C22 4.47 19.53 2 16.48 2H8.52zm9.49 8.74c-.41 0-.75-.34-.75-.75v-2.2l-3.73 3.74c-.15.15-.34.22-.53.22s-.38-.07-.53-.22a.754.754 0 0 1 0-1.06l3.73-3.75H14c-.42 0-.75-.33-.75-.75 0-.41.33-.75.75-.75h4.01c.09 0 .18.03.26.06.03.01.05.02.07.03.06.03.11.06.16.11.02.01.04.03.06.05.05.06.09.12.13.19 0 .01.01.02.01.03.04.08.05.17.05.26.01.01.01.01.01.02v4.02c0 .41-.34.75-.75.75z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldMaximize2);
export default __webpack_public_path__ + "static/media/vuesax-bold-maximize_2.d34880d548c8d1c8b3084a65e1586c48.svg";
export { ForwardRef as ReactComponent };